import { useCallback, useState } from 'react';

import useEffectOnce from 'hooks/use-effect-once';
import { useLocale } from 'state/intl';
import { getApiKey } from 'utils/environment';
import { loadGeolocationLibrary } from 'utils/geolocation';
import logger from 'utils/logger';

export default function useGoogleGeolocationLibrary() {
  const googleMapsApiKey = getApiKey({
    key: 'googleMapsWeb',
    disallowEnvPickerValue: true,
  });
  const { region, language } = useLocale();

  const [libraryLoaded, setLibraryLoaded] = useState(false);

  const demandLibrary = useCallback(async () => {
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        await loadGeolocationLibrary(googleMapsApiKey, { region, language });
        setLibraryLoaded(true);
        return;
      } catch (error) {
        logger.error({
          message:
            `Failed to load Google Maps library for attempt ${attempt}/3` +
            (attempt === 2 ? ' (FINAL ATTEMPT)' : ''),
          error,
        });
      }
    }
  }, [googleMapsApiKey, language, region]);

  useEffectOnce(() => {
    demandLibrary();
  });

  return { demandLibrary, libraryLoaded };
}
